module.exports = __webpack_public_path__ + "static/media/24UHCHR6.ac9b6d3e.jpg";